var _path, _path2, _path3;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgEnergyLabel = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.289 12.378l2.53.24-1.524 2a.238.238 0 00.025.311.26.26 0 00.35.006l3.224-2.779c.206-.18.094-.51-.187-.534l-2.53-.24 1.524-2a.238.238 0 00-.025-.311.26.26 0 00-.35-.006l-3.224 2.779c-.2.18-.088.51.187.534z",
  fill: "#00163F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.022 8.71a.76.76 0 00-1.026-.021l-3.221 2.776-.008.007c-.538.485-.214 1.342.476 1.404l1.633.155-.983 1.29-.005.005a.738.738 0 00.086.964.76.76 0 001.025.022l3.222-2.777.002-.002c.56-.49.218-1.348-.47-1.41l-1.633-.154.983-1.289.004-.006a.738.738 0 00-.085-.964z",
  fill: "#00163F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 5c.67 0 1.27.33 1.63.84L21.5 12l-4.37 6.16c-.36.51-.96.84-1.63.84l-11-.01c-1.1 0-2-.89-2-1.99V7c0-1.1.9-1.99 2-1.99l11-.01zm-11 12h11l3.55-5-3.55-5h-11v10z"
})));
export default SvgEnergyLabel;